import { success, failure, request } from "@/utils/constants";
import {routeConstants} from "@/actions/constants/routeConstants";

const initialState = {
    plans: null,
    error: null,
    loading: false,
    success: false,
};

export const bulkRouteInsert = (state = initialState, action: any) => {
    switch (action.type) {
        case routeConstants.bulkInsertRoutesRequest:
            return {
                ...request,
            };
        case routeConstants.bulkInsertRoutesSuccess:
            return {
                ...success,
                data: action.payload,
            };
        case routeConstants.bulkInsertRoutesFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};

export const updateRoutes = (state = initialState, action: any) => {
    switch (action.type) {
        case routeConstants.updateRoutesRequest:
            return {
                ...request,
            };
        case routeConstants.updateRoutesSuccess:
            return {
                ...success,
                data: action.payload,
            };
        case routeConstants.updateRoutesFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};